<template>
  <div class="ai-widget">
    <!-- AI助手浮窗 -->
    <div class="fixed bottom-6 right-6 z-50">
      <!-- 主按钮 -->
      <button 
        @click="toggleWidget"
        class="bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110"
        :class="{ 'rotate-45': isOpen }"
      >
        <i class="fas fa-robot text-2xl"></i>
      </button>
      
      <!-- 聊天窗口 -->
      <div 
        v-if="isOpen"
        class="absolute bottom-16 right-0 w-80 bg-white rounded-lg shadow-2xl border border-gray-200"
      >
        <!-- 聊天头部 -->
        <div class="bg-gradient-to-r from-purple-500 to-pink-500 text-white p-4 rounded-t-lg">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <i class="fas fa-robot mr-2"></i>
              <span class="font-semibold">AI助手</span>
            </div>
            <button @click="toggleWidget" class="text-white hover:text-gray-200">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        
        <!-- 聊天内容 -->
        <div class="h-64 overflow-y-auto p-4">
          <div class="space-y-4">
            <!-- AI欢迎消息 -->
            <div class="flex items-start">
              <div class="bg-gray-100 rounded-lg p-3 max-w-xs">
                <p class="text-sm text-gray-700">
                  您好！我是您的AI助手，有什么可以帮助您的吗？
                </p>
              </div>
            </div>
            
            <!-- 快捷操作按钮 -->
            <div class="grid grid-cols-2 gap-2">
              <button 
                @click="sendQuickMessage('数据概览')"
                class="bg-blue-100 text-blue-700 text-xs px-3 py-2 rounded-lg hover:bg-blue-200 transition-colors"
              >
                数据概览
              </button>
              <button 
                @click="sendQuickMessage('操作指南')"
                class="bg-green-100 text-green-700 text-xs px-3 py-2 rounded-lg hover:bg-green-200 transition-colors"
              >
                操作指南
              </button>
              <button 
                @click="sendQuickMessage('常见问题')"
                class="bg-yellow-100 text-yellow-700 text-xs px-3 py-2 rounded-lg hover:bg-yellow-200 transition-colors"
              >
                常见问题
              </button>
              <button 
                @click="sendQuickMessage('联系客服')"
                class="bg-purple-100 text-purple-700 text-xs px-3 py-2 rounded-lg hover:bg-purple-200 transition-colors"
              >
                联系客服
              </button>
            </div>
          </div>
        </div>
        
        <!-- 输入框 -->
        <div class="border-t border-gray-200 p-4">
          <div class="flex space-x-2">
            <input 
              v-model="message"
              @keyup.enter="sendMessage"
              type="text" 
              placeholder="输入您的问题..."
              class="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-purple-500"
            >
            <button 
              @click="sendMessage"
              class="bg-purple-500 text-white px-4 py-2 rounded-lg hover:bg-purple-600 transition-colors"
            >
              <i class="fas fa-paper-plane"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiWidget',
  data() {
    return {
      isOpen: false,
      message: ''
    }
  },
  methods: {
    toggleWidget() {
      this.isOpen = !this.isOpen
    },
    sendMessage() {
      if (this.message.trim()) {
        // 这里可以添加发送消息的逻辑
        console.log('发送消息:', this.message)
        this.message = ''
      }
    },
    sendQuickMessage(text) {
      this.message = text
      this.sendMessage()
    }
  }
}
</script>

<style scoped>
.ai-widget {
  font-family: 'Inter', 'PingFang SC', 'Hiragino Sans GB', Arial, sans-serif;
}

/* 自定义滚动条 */
.ai-widget ::-webkit-scrollbar {
  width: 4px;
}

.ai-widget ::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.ai-widget ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.ai-widget ::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style> 